import styled from 'styled-components';
import Text from '../Text';

export default styled(Text)<{ countLines: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.countLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: ${(props) => props.color || 'inherit'};
`;
